import styled, { css } from 'styled-components';
import { breakpoints, pxToRems } from '@awaze/design-system.utils.react';
import { SortIconWithDot } from './icon-with-dot';
import { SortIcon } from './icon-without-dot';
export const StyledSortOptions = styled.div `
  position: relative;
`;
export const StyledSortDisplay = styled.div `
  ${({ theme, hasPadding }) => `
    padding: ${hasPadding ? `${pxToRems(12)} 0` : 0};
    background-color: transparent;
    border: 0;
    font-size: ${pxToRems(theme.FontTextText200MidFontSize)};
    line-height: ${pxToRems(theme.FontTextText200MidLineHeight)};
    font-weight: ${theme.FontTextText500MidFontWeight};
    color: ${theme.ColorThemeLink};
    appearance: none;
    margin-left: ${pxToRems(24)};

    ${!hasPadding &&
    css `
        display: inline-flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
      `}

    @media (min-width: ${breakpoints[0]}px) {
      font-size: ${pxToRems(theme.FontTextText300MidFontSize)};
      line-height: ${pxToRems(theme.FontTextText300MidLineHeight)};
      margin-left: ${pxToRems(32)};
    }
  `}
`;
export const StyledSortDropdown = styled.select `
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  appearance: none;

  &:focus {
    & + ${StyledSortDisplay} {
      text-decoration: underline;
    }
  }
`;
export const StyledSortIconWithDot = styled(SortIconWithDot) `
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  width: ${pxToRems(24)};
  fill: ${({ theme }) => theme.ColorThemeLink};
`;
export const StyledSortIcon = styled(SortIcon) `
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  margin: auto;
  width: ${pxToRems(24)};
  fill: ${({ theme }) => theme.ColorThemeLink};
`;
//# sourceMappingURL=sort-options.styles.js.map